import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ButtonConfig } from '@collab/comp-library';
import { ContactUsService } from './service/contact-us.service';
import { FilesUploadedTableI } from './model/filesUploadedTable';
import { contactUsFormErrors } from '../../constants/form-error.constants';

@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {

    public acceptedFileType = ".xlsx,.png,.PNG";
    public error:string[]=[];
    public errorType:string[]=[];
    public isMaxSizeExceeded = false;
    public isFileType=false;
    public filesUploadedData: FilesUploadedTableI[] = [];
    public uploadAllTestCasesFilesError = false;
    public duplicateFilesUploadedError = false;
    public contactUsForm: UntypedFormGroup = this.createForm();
    public productNamesList = [];
    public categoryNamesList = [];
    public files = [] as any;
    public isErrorExtn = false;
    public isFormSubmitted = false;
    public contactUsFormErrors = contactUsFormErrors;
    public uploadedFiles: any;
    public successfullSubmit = false;
    public browseButtonConfig: ButtonConfig = {
        text: 'Upload Files',
        buttonSize:'small',
        buttonType: 'secondary',
        iconURL: '',
        imageUrl: '',
        linkURL: ''
    };
    public submitButtonConfig: ButtonConfig = {
        text: 'Send',
        buttonType: 'primary',
        iconURL: '',
        imageUrl: '',
        linkURL: ''
    };
    public okButtonConfig: ButtonConfig = {
        text: 'Cancel',
        buttonType: 'secondary',
        buttonSize:'medium',
        iconURL: '',
        imageUrl: '',
        linkURL: ''
    };
    public okSecondaryButtonConfig: ButtonConfig = {
        text: 'OK',
        buttonType: 'primary',
        buttonSize:'medium',
        iconURL: '',
        imageUrl: '',
        linkURL: ''
    };

    public goToHomeButtonConfig: ButtonConfig = {
        text: 'Back To Home',
        buttonType: 'primary',
        iconURL: '',
        imageUrl: '',
        linkURL: ''
    }

    constructor(private formBuilder: UntypedFormBuilder, private contactUsService: ContactUsService) { }

    ngOnInit(): void {
        this.getCategories();
        this.getProductNames();
    }

    /**
     *
     * this method will create a login form
     * @return {*}  {FormGroup}
     * @memberof LoginComponent
     */
    public createForm(): UntypedFormGroup {
        return this.formBuilder.group({
            name: ['', [Validators.required,Validators.pattern("[a-zA-Z ]{5,255}")]],
            email: ['', [Validators.required,Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]],
            contactNumber: ['',[Validators.required,Validators.pattern('[0-9]{10,12}')]],
            productName: ['', [Validators.required]],
            categoryName: ['', [Validators.required]],
            attachFile:[''],
            message: ['', [Validators.required,Validators.pattern("^(?![0-9!+-@#$%^&*_()., ]*$).{8,500}[a-zA-Z0-9!+-@#$%^&*_()., ]+$")]],
        });
    }

    public selectTestType() {
        console.log('');
    }

    public onCancel() {
        this.contactUsService.isContactUsShow = false;
    }



    /**
     * this method will upload the file
     * @returns {void}
     * @param {*} file
     * @memberof FileUploadComponent
     */
    public uploadFile(file: any): void {
        this.error=[];
        this.errorType=[];

        if (file && file.length > 0) {
            if (file[0].size <= 10485760) {
                const element = file[0];
                const fileExtn = '.' + element.name.split('.').pop();
                const acceptedFileTypeArr = this.acceptedFileType.split(',');

                if (acceptedFileTypeArr.indexOf(fileExtn) === -1) {
                    this.isFileType=true;
                    this.errorType.push(this.contactUsFormErrors.attachFile.maxFileSize)
                } else {
                    this.filesUploadedData = [{ documentName: element.name, documentSize: element.size }];
                    this.uploadedFiles = file[0];
                    this.isMaxSizeExceeded=false;
                    this.isFileType=false;
                }
            } else {
                this.isMaxSizeExceeded = true;
                this.isFileType=false;
                this.error.push(this.contactUsFormErrors.attachFile.required);
                return;
            }
        }
    }

    /**
     * this method is used to delete attachment
     * @returns {void}
     * @param {number} index
     * @memberof FileUploadComponent
     */
    public deleteAttachment(): void {
        this.filesUploadedData = [];
        this.uploadedFiles = null;
    }

    public submitContactUs() {
        this.isFormSubmitted = true;

        if (this.contactUsForm.valid) {
            let requestObj;

            requestObj = new FormData();
            requestObj.append('name', this.contactUsForm.getRawValue().name);
            requestObj.append('email', this.contactUsForm.getRawValue().email);
            requestObj.append('contactNo', this.contactUsForm.getRawValue().contactNumber);
            requestObj.append('productId',this.contactUsForm.getRawValue().productName);
            requestObj.append('categoryId',this.contactUsForm.getRawValue().categoryName);
            requestObj.append('message', this.contactUsForm.getRawValue().message);

            if (this.uploadedFiles) {
                requestObj.append('file', this.uploadedFiles);
            }

            this.contactUsService.createContactUs(requestObj).subscribe(() => {
                this.successfullSubmit = true;
            });
        }
    }

    public getCategories() {
        this.contactUsService.getCategoriesList().subscribe(
            (response: any) => {
                this.categoryNamesList = response.map((res: any) => res);
            }
        );
    }

    public getProductNames() {
        this.contactUsService.getproductNamesList().subscribe(
            (response: any) => {
                this.productNamesList = response.map((res: any) => res);
            }
        );
    }

    public goToHome() {
        this.contactUsService.isContactUsShow = false;
    }

    public convertToFormControl(absCtrl: AbstractControl | null): FormControl {
        const ctrl = absCtrl as FormControl;
        return ctrl;
    }
}
